// extracted by mini-css-extract-plugin
export default {"photo":"UserInfo_photo__UauGS"};